module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-pickwick-bottom-01.2.95ce76ef.jpg";